/**
 * Shopware 6.6 storefront integration surface — keep adapter-only; non-Shopware builds
 * should not import this file from shared core paths.
 */

/** Polling interval when observing cookie-based consent heuristics. */
export const CONSENT_POLL_INTERVAL_MS = 1000;

/** Twig-injected JSON blob element (`readInjectedTrackingPage`). */
export const TRACKING_PAGE_ELEMENT_ID = 'birdsview-tracking-page';

/**
 * Customer JSON route — must stay aligned with PHP
 * `Goose\Controller\TrackingCustomerController` route path.
 */
export const TRACKING_CUSTOMER_PATH = '/bv-tracking/customer';
